angular.module('capability-ng-global').config((universityTextConfigProvider: any) => {
  universityTextConfigProvider.write({ addUniversityStyles: false });
});



// WEBPACK FOOTER //
// ./app/lib/global/configuration/university_text_configuration.ts